
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import PagedDataTable from '@/components/PagedDataTable.vue';
import ProductCategoryRepository from '@/repositories/webshop/ProductCategoryRepository';

@Component({
    components: { GeneralScaffold, PagedDataTable },
})
export default class ProductCategoryListScreen extends Vue {
    @Inject()
    private readonly productCategoryRepository!: ProductCategoryRepository;

    public get headers(): any[] {
        return [
            {
                text: this.$t('general.actions'),
                value: 'action',
                sortable: false,
            },
            {
                text: this.$t('crud.product-category.textNl'),
                align: 'left',
                value: 'textNl',
                sortable: true,
            },
            {
                text: this.$t('crud.product-category.textEn'),
                value: 'textEn',
                sortable: true,
            },
        ];
    }
}
